<div class="card harp-reg-card harp-material">
  <div class="card-body">
    <h2 class="harp-card-title">Confirmation</h2>

    <div *ngIf="!profileInfo.manualProofing">
      <div class="row align-items-center">
        <div class="col-md-1 text-center">
          <em
            class="icon ion-ios-checkmark-circle-outline harp-confirmation-check"
          ></em>
        </div>
        <div class="col-md-11">
          Your account has been successfully created. You should receive an
          email shortly containing your user ID and confirming that your account
          was created.
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12">
          <h4 class="harp-card-title">
            Final step: Set up two-factor authentication
            <button
              class="harp-tooltip"
              placement="top"
              ngbTooltip="Two-factor authentication is an extra layer of security on top of a user ID and password that requires a piece of information only accessible by the user, such as a security code via text or phone call"
            >
              <em class="icon ion-md-information-circle" aria-hidden="true"></em
              ><span class="visually-hidden"
                >Two-Factor Authentication Tooltip</span
              >
            </button>
          </h4>
          <p>
            Please log into HARP with your new credentials to set up two-factor
            authentication and complete setting up your account.
          </p>
          <a href="/login" class="btn btn-primary btn-lg mb-4"
            >Login to Complete Setup
            <em class="icon ion-md-arrow-round-forward"></em
          ></a>
          <p>
            Want to help us improve this site?
            <strong
              ><a
                href="https://www.surveymonkey.com/r/ess-signup"
                target="_blank"
                >Sign up<em class="icon ion-md-open"></em></a
            ></strong>
            to participate in future user research.
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="profileInfo.manualProofing">
      <div class="row">
        <div class="col-12">
          <p>
            You have successfully submitted your Profile Information and Account
            Information forms to the Services and Operations Support (SOS) team.
            You will not be able to use your HARP user ID or password to log
            into CMS applications until manual proofing is complete.
          </p>
          <h4 class="harp-card-title">Manual Proofing Next Steps</h4>
          <p>
            To complete the manual proofing for identity verification, please
            send the following documents to the Services and Operations Support
            (SOS) team. You can send secure mail, secure fax, or encrypted
            email. If you have emailed your encrypted documents, you will need
            to send a separate email with your INC# in the subject line and ONLY
            the password in the body of the email.
          </p>
          <ol>
            <li>
              <strong>One</strong> of three approved forms of Government Photo
              IDs:
            </li>
            <ul>
              <li>Current driver's license issued by state or territory; OR</li>
              <li>
                Federal or State government issued photo identification card; OR
              </li>
              <li>U.S. Passport</li>
            </ul>
            <li>
              <strong>Two</strong> copies of financial institution official
              bills or statements addressed to the address used during the
              registration process. Payroll information is also accepted.
            </li>
            <li>
              If you did not fill out the HARP SSN field, you will need to
              provide only the <strong>last four digits of your SSN</strong> to
              the SOS team.
            </li>
          </ol>
          <p>
            The Services and Operations Support (SOS) team will contact you via
            email if they need to request additional information.
          </p>
          <p>
            For any questions related to manual proofing, contact the Services
            and Operations Support (SOS) team, Monday - Friday 8:00 AM - 8:00 PM
            EST by phone 1-866-288-8914 or email
            <a href="mailto:identity.proofing@cms.hhs.gov"
              >identity.proofing&#64;cms.hhs.gov</a
            >.
          </p>
          <p>
            Upon successful manual proofing, you will receive an email
            confirming your account creation. Log into HARP with your user ID
            and password to set up two-factor authentication.
          </p>
          <a
            href="/login/contact"
            class="btn btn-primary btn-lg harp-button-margin"
          >
            Contact SOS Team
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
